// eslint-disable-next-line import/prefer-default-export
export const setTitle = function (title) { window.document.getElementsByTagName('title')[0].innerHTML = title }
